// EditProfile/index.tsx

import { CircularProgress, Divider, Grid2 as Grid } from '@mui/material'
import SimpleTitle from 'components/SimpleTitle'
import useAuth from 'hooks/useAuth'
import React from 'react'
import LoginSessionsSection from './LoginSessionsSection'
import OrganizationsSection from './OrganizationsSection'
import PasswordSection from './PasswordSection'
import ProfileSection from './Profile'
import TwoStepAuthSection from './TwoStepSection'

const EditProfilePage: React.FC = () => {
  const { profile, isLoading: isLoadingProfile } = useAuth()

  if (!profile) return null

  return isLoadingProfile ? (
    <Grid container spacing={12}>
      <Grid
        size={{ xs: 12 }}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress color="primary" />
        Loading
      </Grid>
    </Grid>
  ) : (
    <>
      <SimpleTitle title="Profile" />
      <ProfileSection profile={profile} />
      <Divider style={{ width: '100%', margin: '40px 0' }} />
      <PasswordSection />
      <Divider style={{ width: '100%', margin: '40px 0' }} />
      <TwoStepAuthSection />
      <Divider style={{ width: '100%', margin: '40px 0' }} />
      <LoginSessionsSection />
      <Divider style={{ width: '100%', margin: '40px 0' }} />
      <OrganizationsSection profile={profile} />
    </>
  )
}

export default EditProfilePage
